import { GtmTracker } from '@/modules/common/services/analytics';
import { Categories } from '@/types/models/Analytics';

const trackEvent = GtmTracker.trackerWithDefaultProps({
  category: Categories.PEX
});

export function trackingCloseBtnStepDetail() {
  trackEvent({
    action: 'Clique fechar',
    label: 'Detalhe - Sugestao de investimento'
  });
}

export function trackingBackBtnStepDetail() {
  trackEvent({
    action: 'Clique voltar',
    label: 'Detalhe - Sugestao de investimento'
  });
}

export function closeButtonWalletDetail() {
  trackEvent({
    action: 'Clique fechar',
    label: 'Sugestao de investimento'
  });
}
